<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <el-tabs>
        <el-tab-pane :key="1" label="基础信息">
            <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="供应商:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="lifnr">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.lifnr" placeholder="供应商" size="small"></el-input>
                                <span v-else>{{dataForm.lifnr}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="name1">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.name1" placeholder="供应商名称" size="small"></el-input>
                                <span v-else>{{dataForm.name1}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料凭证号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="belnr">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.belnr" placeholder="物料凭证号" size="small"></el-input>
                                <span v-else>{{dataForm.belnr}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料凭证年度:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="gjahr">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.gjahr" placeholder="物料凭证年度" size="small"></el-input>
                                <span v-else>{{dataForm.gjahr}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="凭证日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="bldat">
                                <el-date-picker v-if="viewFlag !== 'view'" v-model="dataForm.bldat" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                                </el-date-picker>
                                <span v-else>{{dateFormatValue(dataForm.bldat)}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="过账日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="budat">
                                <el-date-picker v-if="viewFlag !== 'view'" v-model="dataForm.budat" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                                </el-date-picker>
                                <span v-else>{{dateFormatValue(dataForm.budat)}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>

                <el-row :gutter="40">
                    <el-col :span="24" style="text-align:right;">
                        <el-button size="small" @click="viewData.visible = false">
                            取消
                        </el-button>
                        <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()" :loading="loading">
                            保存
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :key="2" label="项目">
            <!-- tab -->
            <!-- 美日欧英RMB -->
            <el-button size="small" v-if="isAuth('sys:org:savebutton') && viewFlag !== 'view'" type="primary" @click="addOrUpdateDetailHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                新增项目
            </el-button>
            <el-table :data="detailList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="belnr" header-align="center" align="left" label="物料凭证号" width="150">
                </el-table-column>
                <el-table-column prop="buzei" header-align="center" align="left" label="物料凭证项目" width="150">
                </el-table-column>
                <el-table-column prop="vbeln" header-align="center" align="left" label="ASN单号" width="150">
                </el-table-column>
                <el-table-column prop="ebeln" header-align="center" align="left" label="采购订单号" width="150">
                </el-table-column>
                <el-table-column prop="ebelp" header-align="center" align="left" label="采购订单项目编号" width="150">
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="left" label="物料编码" width="150">
                </el-table-column>
                <el-table-column prop="charg" header-align="center" align="right" label="批次" width="150">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="left" label="描述" width="150">
                </el-table-column>
                <el-table-column prop="menge" header-align="center" align="right" label="数量" width="150">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="基本单位" width="150">
                    <template slot-scope="scope">
                        <span>{{getUnitName(scope.row.meins)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bwart" header-align="center" align="left" label="移动类型" width="150">
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="150">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.werks)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lgort" header-align="center" align="left" label="库存地点" width="150">
                </el-table-column>
                <el-table-column prop="sgtxt" header-align="center" align="left" label="项目文本" width="150">
                </el-table-column>
                <el-table-column prop="lgobe" header-align="center" align="left" label="库存地点名称" width="150">
                </el-table-column>
                <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addOrUpdateDetailHandle(scope.row.id)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteDetail(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
            </el-pagination>
        </el-tab-pane>
    </el-tabs>
    <add-or-update-detail v-if="addOrUpdateDetailVisibe" ref="addOrUpdateDetail" @refreshDetailDataList="getDeliveryHistoryDetailList"></add-or-update-detail>
</el-dialog>
</template>

<script>
import {
    editDeliveryHistory,
    createDeliveryHistory,
    getByDeliveryHistoryId,
    getDeliveryHistoryDetailList,
    removeDeliveryHistoryDetail
} from '@/controller/sap'
import {
    getFactoryList,
    getUnitList,
    getStorePositionTypeList
} from '@/controller/systemData'
import AddOrUpdateDetail from './detail-add-or-update'
import moment from 'moment'
// require('@/mock/mockProject');
export default {
    data() {
        return {
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            factoryList: [],
            unitList: [],
            detailList: [],
            storePositionTypeList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataForm: {
                id: 0,
                lifnr: '',
                name1: '',
                belnr: '',
                gjahr: '',
                bldat: '',
                budat: '',
            },
            addOrUpdateDetailVisibe: false,
            dataRule: {
                // projectManagerId: [{
                //     required: true,
                //     message: '项目负责人名称不能为空',
                //     // trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            }
        }
    },
    mounted() {},
    components: {
        AddOrUpdateDetail
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        init(data, id, viewFlag) {
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.detailList = [];
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getByDeliveryHistoryId({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                        }
                    });
                    this.getDeliveryHistoryDetailList()
                }
                this.getUnitList()
                this.getFactoryList()
                this.getStorePositionTypeList()
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 1000)
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    if (this.dataForm.id) {
                        editDeliveryHistory(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createDeliveryHistory(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDeliveryHistoryDetailList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDeliveryHistoryDetailList();
        },
        getDeliveryHistoryDetailList() {
            getDeliveryHistoryDetailList({
                historyId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.detailList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.detailList = [];
                    this.totalPage = 0;
                }
            });
        },
        //删除detail
        deleteDetail(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    removeDeliveryHistoryDetail({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDeliveryHistoryDetailList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        // 新增 / 修改
        addOrUpdateDetailHandle(id) {
            this.addOrUpdateDetailVisibe = true
            this.$nextTick(() => {
                this.$refs.addOrUpdateDetail.init(id, this.dataForm.id)
            })
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        //获取单位数据
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        //获取库存地点数据
        getStorePositionTypeList() {
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            return factory ? factory.factoryDesc : ''
        },
        getStorePositionTypeName(val) {
            const storePositionType = this.storePositionTypeList.find(storePositionType => storePositionType.storeAddress === val)
            return storePositionType ? storePositionType.storeName : ''
        },
        getStyle() {
            return 'width: 160px; text-align: right'
        },
        getStyle2() {
            return 'width: 395.5px;'
        }
    },
}
</script>
